<template>
  <RouterLink
    v-if="profileLink"
    class="author-link author-link--linked"
    :to="{ name: 'public-profile', params: { username: author.username } }"
    @click="onClick"
  >
    <UserIdentity :user="author" :size="size">
      <slot>{{ label }}</slot>
    </UserIdentity>
  </RouterLink>
  <span v-else class="author-link" @click="onClick">
    <UserIdentity :user="author" :size="size">
      <slot>{{ label }}</slot>
    </UserIdentity>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import UserIdentity from './UserIdentity.vue'
import { userDisplayName } from '../utils/userDisplay'

const props = defineProps({
  author: {
    type: Object,
    required: true,
  },
  prefix: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'md',
  },
  stopPropagation: {
    type: Boolean,
    default: false,
  },
})

const profileLink = computed(() => {
  return Boolean(props.author?.username)
})

const label = computed(() => {
  const name = userDisplayName(props.author)
  return props.prefix ? `${props.prefix} ${name}` : name
})

function onClick(event) {
  if (props.stopPropagation) {
    event.stopPropagation()
  }
}
</script>

<style scoped>
.author-link {
  color: inherit;
  text-decoration: none;
}

.author-link--linked:hover :deep(.user-identity-name) {
  text-decoration: underline;
}
</style>
